import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/core/auth/auth.guard';
import { CanActivateChildGuard } from 'src/app/core/guards/can-activate-child.guard';
import { ListLaborUtilizationReportComponent } from './list-labor-utilization-report/list-labor-utilization-report.component';

const routes: Routes = [
  {
    path: '',
    component: ListLaborUtilizationReportComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./list-labor-utilization-report/list-labor-utilization-report.module').then(m => m.ListLaborUtilizationReportModule),
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LaborUtilizationReportRoutingModule { }
